
  export default {
    name: 'CurrentTime',
    data() {
      return {
        timezone: 'UTC+07:00',
        timeInterval: null,
        time: '-',
        date: '-'
      }
    },
    created() {
      const now = this.$dayjs()
      this.time = now.format('HH:mm:ss')
      this.date = now.format('DD-MM-YYYY')
    },
    mounted() {
      this.startTimeUpdate()
    },
    beforeDestroy() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
    },
    methods: {
      startTimeUpdate() {
        const now = this.$dayjs()
        const msUntilNextSecond = 1000 - now.millisecond()

        setTimeout(() => {
          this.updateTime()
          this.timeInterval = setInterval(() => this.updateTime(), 1000)
        }, msUntilNextSecond)
      },
      updateTime() {
        const now = this.$dayjs()
        this.time = now.format('HH:mm:ss')
        this.date = now.format('DD-MM-YYYY')
      }
    }
  }
